import { DealResponseCodes } from '../../common/enum/DealResponseCodes';

export const dealError = {
  dealerNotFoundOnDeal(dealError: any): boolean {
    return dealError?.response?.data?.code === DealResponseCodes.DEALER_NOT_FOUND;
  },

  dealIsExpired(dealError: any): boolean {
    return dealError?.response?.data?.code === DealResponseCodes.EXPIRED_DEAL;
  },
};
